
export enum NotificationCd {
	APPT_EXISTS = 'ApptExists',
	APPT_NOT_RQRD = 'ApptNotRqrd',
	NTFICTN_EXISTS = 'NtfictnExists',
	RE_APPT_CANDIDATE = 'ReApptCandidate'}

